import ConfigurationLoader from '../core/configurationLoader';
import UnmatchedBreakpointException from '../exceptions/unmatchedBreakpointException';
/** The name of the module */
export const name = 'Breakpoints';
/**
 * Get the breakpoint for a provided width
 *
 * @param width The width to look up the breakpoint for
 */
export const getBreakpoint = (width) => {
    // Compare the current viewport width to each breakpoint size to find the current breakpoint
    const breakpoints = ConfigurationLoader.get('breakpoints');
    const matchedBreakpoint = Object.values(breakpoints).find((breakpoint) => {
        if (width >= breakpoint.minimum && width < breakpoint.maximum) {
            return breakpoint;
        }
        return false;
    });
    if (!matchedBreakpoint) {
        throw new UnmatchedBreakpointException(width);
    }
    return matchedBreakpoint;
};
export const getBreakpointByName = (breakpointName) => {
    const { [breakpointName]: breakpoint } = ConfigurationLoader.get('breakpoints');
    return breakpoint;
};
/**
 * Get the breakpoint for the current viewport width
 */
export const getCurrentBreakpoint = () => {
    // Get the width, in px, of the viewport
    const width = document.body.offsetWidth;
    return getBreakpoint(width);
};
/**
 * Boolean to determine if viewport is in a given breakpoint
 * @param breakpoint The name of the breakpoint to compare to
 */
export const isCurrentBreakpoint = (breakpoint) => {
    if (getCurrentBreakpoint() === breakpoint) {
        return true;
    }
    return false;
};
